import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Wide Smile.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              My programming journey started with a simple decision, and the deeper I went,
  the more fascinated I became. 🤷‍♂️
              <br />
              <br />I feel most comfortable working with
              <i>
                <b className="purple"> Python and JavaScript. </b>
              </i>
              <br />
              <br />
              Right now, I’m focused on &nbsp;
              <i>
                <b className="purple">Full Stack Development </b>
              </i>
              using tools like
              <i>
                <b className="purple"> Django and React, </b>
              </i>
              but my long-term passion lies in
              <i>
                <b className="purple"> working on AI-driven solutions, </b>
              </i>
              especially with machine learning.  
              <br />
              <br />
              I enjoy building products that combine creativity and problem-solving, and I’m
              always excited to learn and explore new technologies that push me further in
              this journey.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/AbrhamAb"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/Abrham_abebawE"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/abrham-abebaw/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/abraham_abebaw_/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
